import { theme } from "../theme";

// One set of consultant-grade colours for every page that shows a grade (rate card,
// bookings, calendar, schedule). Theme tokens, so the light, dark and brand schemes
// all carry them; a grade is a category, not a status.

export type GradeId = "senior" | "consultant" | "junior";

export const GRADE_STYLE: Record<GradeId, { label: string; color: string; bg: string }> = {
  senior:     { label: "Senior",     color: theme.color.accentText,  bg: theme.color.accentBg },
  consultant: { label: "Consultant", color: theme.color.consultant,  bg: theme.color.consultantBg },
  junior:     { label: "Junior",     color: theme.color.warningText, bg: theme.color.warningBg },
};

export function gradeStyle(grade: string | null | undefined): { label: string; color: string; bg: string } {
  return GRADE_STYLE[(grade ?? "") as GradeId] ?? { label: grade ?? "Unset", color: theme.color.subtle, bg: theme.color.panelAlt };
}
